import { CircularProgress } from '@material-ui/core'
import { Fragment } from 'react'

function LoadingContainer(): JSX.Element {
  return (
    <Fragment>
      <div
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          backgroundColor: '#fff',
          height: '100%',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 2
        }}
      >
        <CircularProgress color='primary' />
      </div>
    </Fragment>
  )
}

export default LoadingContainer
